import {
  escapeHtml,
  resolveIconPath,
  sortByImportanceDesc
} from "./utils/spot_utils";

export function normalizeWrappedCoordinates(clickedLng, coordinates) {
  const nextCoordinates = [...coordinates];

  while (Math.abs(clickedLng - nextCoordinates[0]) > 180) {
    nextCoordinates[0] += clickedLng > nextCoordinates[0] ? 360 : -360;
  }

  return nextCoordinates;
}

export function buildPopupHtml({
  props,
  categoriesById,
  otherTagsById,
  wirelessTagsById,
  infoIconSize,
  imageBaseUrl = ""
}) {
  const name = escapeHtml(props.name || "名称未設定スポット");
  const address = escapeHtml(props.address || "住所情報は準備中です");
  const category = props.primeCategoryId ? categoriesById[String(props.primeCategoryId)] : null;
  const categoryAlt = category?.name || "カテゴリ画像";

  const popupOtherTags = sortByImportanceDesc(
    (props.otherTagIdsCsv || "").split(",").filter(Boolean)
      .map((id) => otherTagsById[id]).filter((tag) => tag?.image)
  );
  const popupWirelessTags = sortByImportanceDesc(
    (props.wirelessTagIdsCsv || "").split(",").filter(Boolean)
      .map((id) => wirelessTagsById[id]).filter((tag) => tag?.image)
  );
  const popupInfoTags = [...popupOtherTags, ...popupWirelessTags];

  const categoryImagePath = category?.image
    ? resolveIconPath(category.image, infoIconSize, imageBaseUrl)
    : null;
  const popupIconItems = [
    categoryImagePath
      ? `<li class="inline-block" title="${escapeHtml(categoryAlt)}"><img src="${escapeHtml(categoryImagePath)}" alt="${escapeHtml(categoryAlt)}" style="width:${infoIconSize}px;height:${infoIconSize}px;object-fit:contain" /></li>`
      : "",
    ...popupInfoTags.map((tag) => `<li class="inline-block" title="${escapeHtml(tag.name || "")}"><img src="${escapeHtml(tag.image)}" alt="${escapeHtml(tag.name || "")}" style="width:${infoIconSize}px;height:${infoIconSize}px;object-fit:contain" /></li>`)
  ].filter(Boolean);

  const iconsHtml = popupIconItems.length
    ? `<ul class="flex flex-wrap gap-1 list-none p-0 m-0">${popupIconItems.join("")}</ul>`
    : "";

  return `
    <div class="rounded-xl bg-white p-4" style="min-width:200px;max-width:280px;">
      ${iconsHtml ? `<div class="mb-3">${iconsHtml}</div>` : ""}
      <h3 class="text-sm font-semibold text-[#337ab7] leading-snug">${name}</h3>
      <p class="mt-2 text-xs leading-5 text-slate-600">${address}</p>
    </div>
  `;
}

export function createPopupController({
  map,
  mapboxgl,
  categoriesById,
  otherTagsById,
  wirelessTagsById,
  infoIconSize,
  imageBaseUrl = ""
}) {
  let activePopup = null;

  return {
    handleSpotsSymbolClick(event) {
      const feature = event.features[0];
      if (!feature) return;

      const coordinates = normalizeWrappedCoordinates(event.lngLat.lng, feature.geometry.coordinates.slice());
      const popupHtml = buildPopupHtml({
        props: feature.properties,
        categoriesById,
        otherTagsById,
        wirelessTagsById,
        infoIconSize,
        imageBaseUrl
      });

      if (activePopup) activePopup.remove();
      activePopup = new mapboxgl.Popup({ closeButton: true, maxWidth: "300px" })
        .setLngLat(coordinates)
        .setHTML(popupHtml)
        .addTo(map);
    }
  };
}
